module.exports = __webpack_public_path__ + "img/subpart@2x.bafb1e80.png";